import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  extra?: ReactNode;
  as?: "h2" | "h3";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  extra,
  as = "h2",
}: SectionHeadingProps) {
  const Tag = as;
  return (
    <div className="flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
      <div className="max-w-2xl">
        {eyebrow && (
          <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
            <span className="h-px w-6 bg-primary-400"></span>
            {eyebrow}
          </p>
        )}
        <Tag className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
          {title}
        </Tag>
        {desc && <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-base">{desc}</p>}
      </div>
      {extra}
    </div>
  );
}